import React from 'react'
//import { getUrl, getDescText, getPublishDate, getEventDate, cacheFunc } from '../../common/services/builders';
import { getUrl, getDescText } from '../../common/services/builders';


function ListingCard({ entry }) {
    return (
        <div className="column large-4">
            <article className="ui-card" style={{minHeight: 460 + 'px'}}>
                <div className="ui-card__image">
                    <div className="ui-card__image-container" style={renderImage(entry)}></div>
                </div>
                <div className="ui-card__type" style={{top: 220 +'px'}}>
                    {entry.topic}
                </div>
                <div className="ui-card__content  text-center">
                    <h3 className="ui-card__heading"><a href={getUrl(entry)}>{entry.title}</a></h3>
                    <p className="ui-card__text">{entry.shortDescription}</p>
                    <div className="ui-card__tags" style={{textAlign: 'left'}}>
                        Duration: {entry.durationhrs} Hours<br/>
                        Price: &pound;{entry.coursePrice}+VAT where applicable
                    </div>
                </div>
            </article>
        </div>
    )
}
function renderImage(entry){
    let styles = {};
    if(entry.thumbnailuri != null ){
        styles = {backgroundImage: `url(${entry.thumbnailuri})`};
    }
    else{
        styles = {backgroundImage: `url(/CachedImage.axd?ImageName=/site-elements/images/hero/hero-slider-1.jpg&ImageHeight=300&ImageWidth=500)`};
    }
    return styles;
}

export default ListingCard;